/**
 * File track-bounce.js.
 * Handles firing Segment event when user interacts with the page
 */

function trackInteraction(cb = () => {}) {
  fireBounceEvent(0, cb);
  document.removeEventListener('scroll', trackInteraction);
  document.removeEventListener('click', handleClick);
}

function fireBounceEvent(bounce, cb = () => { }) {
  const properties = {
    bounce: bounce,
  };

  segment('track', 'Bounce', properties, cb);
}

function handleClick(e) {
  if (e.target && e.target.href) {
    const goToUrl = redirect(e.target.href);

    sscmsPreventDefault(e);
    trackInteraction(goToUrl);
  } else {
    trackInteraction();
  }
}

// assume user will bounce
window.addEventListener('load', function () {
  fireBounceEvent(1);
});

// user scrolled, did not bounce
document.addEventListener('scroll', trackInteraction);

// user clicked, did not bounce
document.addEventListener('click', handleClick);
